import { scheduledEvent } from './reducers';
export default scheduledEvent;
